import menuImage1 from "./Images/Idli.jpeg"
import menuImage2 from "./Images/Dosa.jpg"
import menuImage3 from "./Images/Kori Gassi.jpeg"
import menuImage4 from "./Images/Pongal.jpeg"
import menuImage5 from "./Images/Haleem.jpeg"
import menuImage6 from "./Images/Hyderabadi Dum Biryani.jpeg"
import menuImage7 from "./Images/pollichathu.jpeg"
import menuImage8 from "./Images/Payasam.jpeg"
import menuImage9 from "./Images/Mysore paak.jpeg"
import reviewImage1 from "./Images/Yash.jpg";
import reviewImage2 from "./Images/Vijay.jpg";
import reviewImage3 from "./Images/Ram charan.jpg";

const menu = [
    {
        name:"Idli-Vada",
      img: menuImage1,
      price:100

    },
    {
        name:"Masala Dosa",
      img: menuImage2,
      price:120
    },
    {
        name:"Kori Gassi",
      img: menuImage3,
      price:150
    },
    {
        name:"Pongal",
      img: menuImage4,
      price:200
    },
    {
        name:"Haleem",
      img: menuImage5,
      price:250
    },
    {
        name:"Hyderabadi Dum Biriyani",
      img: menuImage6,
      price:270
    },
    {
        name:"Pollichathu",
      img: menuImage7,
      price:250
    },


    {
        name:"Payasam",
      img: menuImage8,
      price:100
    },
    {
        name:"Mysore paak",
      img: menuImage9,
      price:150
    },
  ];

  const review = [
    {
      img: reviewImage1,
      name:"Yash",
      des:"Nirvana Hotel encapsulates South Indian culinary brilliance, harmonizing the aromatic flavors of Hyderabad, the coastal richness of Kerala, and Karnataka's diverse palate. It's an exceptional destination for those seeking authentic regional delicacies."
    },
    {
      img: reviewImage2,
      name:"Vijay",
      des:"Nirvana Hotel seamlessly blends the essence of South Indian cuisine, offering a tantalizing journey through the vibrant flavors of Hyderabad, the rich textures of Kerala, and the aromatic allure of Karnataka, all in one gastronomic haven."
    },
    {
      img: reviewImage3,
      name:"Ram Charan",
      des:"Embark on a flavorful expedition at Nirvana Hotel, where South Indian culinary traditions come alive. Delight in the vibrant tastes of Hyderabad, the coastal indulgences of Kerala, and the aromatic wonders of Karnataka, all harmoniously served on your plate"
    },
  ];

  export {menu,review};